// This file was once generated when you created this area
// but you can edit it freely

import { transformRoutes } from '@backoffice-frontend/common'

const BaseIncidentAnalysisAreaRoutes = {
  route: '/incident-analysis',
}

export const IncidentAnalysisAreaRoutes = transformRoutes(
  BaseIncidentAnalysisAreaRoutes,
)
